/**
 * GiftCardEmailFailedWarning — shown on a freshly created card whose email to
 * the recipient did not send, so staff pass the number on another way.
 */
export function GiftCardEmailFailedWarning({ email }: { email: string }) {
  return (
    <div
      role="alert"
      className="nb-card nb-card-tight"
      style={{
        padding: 16,
        marginBottom: 16,
        borderLeft: '3px solid var(--nb-warn)',
        fontSize: 13,
      }}
    >
      The gift card was created, but the email to {email} did not send. Share the card number with
      them another way.
    </div>
  );
}
